import React from 'react';
import './RatingCard.css';

function RatingCard({ rating }) {
  const renderStars = (ratingValue) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <span key={i} className={`star ${i <= ratingValue ? 'full' : 'empty'}`}>
          ★
        </span>
      );
    }
    return stars;
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return 'Recently';
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  };

  return (
    <div className="rating-card">
      <div className="rating-card-header">
        <div className="rating-user">
          <span className="user-avatar">
            {rating.userEmail ? rating.userEmail.charAt(0).toUpperCase() : '?'}
          </span>
          <div>
            <div className="user-email">{rating.userEmail || 'Anonymous'}</div>
            <div className="rating-date">{formatDate(rating.createdAt)}</div>
          </div>
        </div>
        <div className="rating-stars">
          {renderStars(rating.foodRating)}
        </div>
      </div>
      
      {rating.comment && (
        <div className="rating-comment">
          {rating.comment}
        </div>
      )}
      
      <div className="rating-label">
        Food Quality Rating
      </div>
    </div>
  );
}

export default RatingCard;

